import { useTranslation } from 'next-i18next'
import { TabItemType } from '../utils/types'

export const useCategoryList = () => {
  const { t } = useTranslation()
  const SEARCH_CATEGORIES: TabItemType[] = [
    {
      label: t('Search_Category_Tab_All'),
      value: 'all',
    },
    {
      label: t('Search_Category_Tab_Live'),
      value: 'live',
    },
    {
      label: t('Search_Category_Tab_Products'),
      value: 'products',
    },
    {
      label: t('Search_Category_Tab_Vendor'),
      value: 'vendor',
    },
    {
      label: t('Search_Category_Tab_KOL'),
      value: 'kol',
    },
  ]
  return SEARCH_CATEGORIES
}
